export enum EstimateStatus {
  PENDING = 'PENDING',
  ESTIMATE = 'ESTIMATE',
  RESERVED = 'RESERVED',
  REFUSED = 'REFUSED',
}
